const fileExplorer = {
  toolbar: {
    gridView: 'Vista de cuadricula',
    listView: 'Vista de lista',
    searchPlaceholder: 'Buscar archivos...',
    searchAriaLabel: 'Buscar archivos',
    upload: 'Cargar',
    uploadAriaLabel: 'Cargar archivos',
    newFolder: 'Nueva Carpeta',
    newFolderAriaLabel: 'Crear nueva carpeta',
    setAsTemplate: 'Establecer como Plantilla',
    setAsTemplateAriaLabel: 'Establecer archivo seleccionado como plantilla',
    done: 'Listo',
    select: 'Seleccionar',
    exitSelectionAriaLabel: 'Salir del modo de seleccion',
    enterSelectionAriaLabel: 'Entrar en modo de seleccion',
    viewModeAriaLabel: 'Modo de vista',
  },
  empty: {
    noFiles: 'No se encontraron archivos',
    noFilesInFolder: 'Esta carpeta esta vacia',
    noSearchResults: 'Ningun archivo coincide con tu busqueda',
    searchResultsHint: 'Intenta ajustar los terminos de busqueda',
    dragDropHint: 'Arrastra y suelta archivos aqui para subirlos',
  },
  fileList: {
    headers: {
      name: 'Nombre',
      modified: 'Modificado',
      size: 'Tamano',
      type: 'Tipo',
    },
  },
  tree: {
    root: 'Archivos',
  },
  errorLoading: 'Error al cargar archivos',
};

const fileActions = {
  upload: 'Subir',
  newFolder: 'Nueva Carpeta',
  rename: 'Renombrar',
  move: 'Mover',
  moveTo: 'Mover a...',
  share: 'Compartir',
  download: 'Descargar',
  delete: 'Eliminar',
  open: 'Abrir',
  select: 'Seleccionar',
  setAsTemplate: 'Establecer como Plantilla',
  downloadingFile: 'Descargando {name}',
  failedToDownload: 'Error al descargar archivo',
};

const bulkActions = {
  itemSelected: '{count} elemento seleccionado',
  itemsSelected: '{count} elementos seleccionados',
  deselectAll: 'Deseleccionar Todo',
  selectAll: 'Seleccionar Todo',
  download: 'Descargar',
  moveTo: 'Mover a...',
  delete: 'Eliminar',
  downloadingFile: 'Descargando archivo',
  downloadingArchive: 'Descargando {count} archivos como {name}',
  failedToDownload: 'Error al descargar: {error}',
  clearSelectionAriaLabel: 'Limpiar seleccion',
  bulkFileActionsAriaLabel: 'Acciones masivas de archivos',
};

const templateDialog = {
  title: 'Establecer Documento como Plantilla',
  settingAs: 'Estableciendo {name} como plantilla',
  documentType: 'Tipo de Documento',
  selectDocumentType: 'Seleccionar un tipo de documento',
  cancel: 'Cancelar',
  setAsTemplate: 'Establecer como Plantilla',
  successUpdated: 'Configuracion de plantilla actualizada exitosamente',
  failedToUpdate: 'Error al actualizar la configuracion de plantilla',
};

const dialogs = {
  upload: {
    title: 'Subir Archivos',
    dropzone: 'Arrastra y suelta archivos aqui o haz clic para buscar',
    filesToUpload: 'Archivos a subir',
    uploading: 'Subiendo...',
    upload: 'Subir',
    uploadComplete: 'Subida completada',
    uploadFailed: 'Error al subir',
    errorFailed: 'Error al subir {filename}',
    statusFailed: 'Fallido',
    cancel: 'Cancelar',
  },
  createFolder: {
    title: 'Crear Nueva Carpeta',
    label: 'Nombre de la Carpeta',
    placeholder: 'Ingresa el nombre de la carpeta',
    create: 'Crear Carpeta',
    cancel: 'Cancelar',
    errorNoName: 'Por favor ingresa un nombre para la carpeta',
    successCreated: 'Carpeta "{name}" creada exitosamente',
    errorFailed: 'Error al crear la carpeta',
  },
  rename: {
    title: 'Renombrar',
    titleFile: 'Renombrar Archivo',
    titleFolder: 'Renombrar Carpeta',
    label: 'Nuevo Nombre',
    placeholder: 'Ingresa el nuevo nombre',
    save: 'Renombrar',
    cancel: 'Cancelar',
    errorNoName: 'Por favor ingresa un nombre de archivo',
    errorNoFile: 'No se selecciono ningun archivo',
    successRenamed: 'Renombrado a "{name}"',
    errorFailed: 'Error al renombrar el archivo: {error}',
  },
  move: {
    title: 'Mover',
    titleFile: 'Mover Archivo',
    titleFolder: 'Mover Carpeta',
    moving: 'Moviendo: "{name}"',
    selectDestination: 'Selecciona la carpeta de destino',
    labelDestination: 'Carpeta de Destino',
    optionRoot: 'Carpeta Raiz',
    move: 'Mover',
    cancel: 'Cancelar',
    errorNoFile: 'No se selecciono ningun archivo',
    successMoved: '"{name}" movido a {destination}',
    errorFailed: 'Error al mover el archivo: {error}',
  },
  delete: {
    title: 'Eliminar',
    titleFile: 'Eliminar Archivo',
    titleFolder: 'Eliminar Carpeta',
    message: 'Estas seguro de que deseas eliminar "{name}"?',
    warningFolder:
      'Advertencia: Esto tambien eliminara todos los archivos y carpetas dentro.',
    warningPermanent: 'Esta accion no se puede deshacer.',
    confirm: 'Eliminar',
    cancel: 'Cancelar',
    errorNoFile: 'No se selecciono ningun archivo',
    successDeleted: '"{name}" eliminado exitosamente',
    errorFailed: 'Error al eliminar: {error}',
  },
  bulkDelete: {
    title: 'Eliminar {count} elemento',
    titlePlural: 'Eliminar {count} elementos',
    message: 'Estas seguro de que deseas eliminar los siguientes elementos?',
    fileCount: '{count} archivo',
    fileCountPlural: '{count} archivos',
    folderCount: '{count} carpeta',
    folderCountPlural: '{count} carpetas',
    warningFolders:
      'Advertencia: Eliminar carpetas eliminara permanentemente todo su contenido.',
    warningPermanent: 'Esta accion no se puede deshacer.',
    confirm: 'Eliminar',
    cancel: 'Cancelar',
    successDeleted: '{count} elemento eliminado',
    successDeletedPlural: '{count} elementos eliminados',
    errorFailed: 'Error al eliminar {count} elemento',
    errorFailedPlural: 'Error al eliminar {count} elementos',
    errorGeneral: 'Error al eliminar archivos: {error}',
  },
  bulkMove: {
    title: 'Mover {count} elemento',
    titlePlural: 'Mover {count} elementos',
    moving: 'Moviendo {count} elemento:',
    movingPlural: 'Moviendo {count} elementos:',
    fileCount: '{count} archivo',
    fileCountPlural: '{count} archivos',
    folderCount: '{count} carpeta',
    folderCountPlural: '{count} carpetas',
    labelDestination: 'Carpeta de Destino',
    optionRoot: 'Carpeta Raiz',
    move: 'Mover',
    cancel: 'Cancelar',
    errorNoFiles: 'No se seleccionaron archivos',
    successMoved: '{count} elemento movido a {destination}',
    successMovedPlural: '{count} elementos movidos a {destination}',
    errorFailed: 'Error al mover {count} elemento',
    errorFailedPlural: 'Error al mover {count} elementos',
    errorGeneral: 'Error al mover archivos: {error}',
  },
};

export const es = {
  fileExplorer,
  fileActions,
  bulkActions,
  templateDialog,
  dialogs,
};
